import { render, staticRenderFns } from "./agv-ri-cp.vue?vue&type=template&id=0483d3ef&scoped=true&lang=pug&"
import script from "./agv-ri-cp.vue?vue&type=script&lang=js&"
export * from "./agv-ri-cp.vue?vue&type=script&lang=js&"
import style0 from "./agv-ri-cp.vue?vue&type=style&index=0&id=0483d3ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0483d3ef",
  null
  
)

export default component.exports